module.exports = __webpack_public_path__ + "static/media/strawberries.9524c237.png";